import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ONBOARDING_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  communityId: string
}

const mutateValidateBulkUploadProperty = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(`${ONBOARDING_API(communityId)}/properties/validate`, data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useValidateBulkUploadPropertyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateValidateBulkUploadProperty,
    ...queryParams,
  });

export default useValidateBulkUploadPropertyMutation;
